import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

/** Doc value can't be biggert then 160 or less than 0 */
export function forbiddenDocValidator(docValueMax: number, docValueMin : number): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const forbidden = control.value < docValueMin || control.value > docValueMax;
    return forbidden ? {forbiddenValue: {value: control.value}} : null;
  };
}

export const MTBOValidator: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const forbidden = control.value < control.get("min") || control.value > control.get("max");
    return forbidden ? {forbiddenValue: {value: control.value}} : null;
  };
};

export const AzimuthRangeValidator: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
  const start = control.get('minazimuth')? control.get('minazimuth').value : null;
  const end = control.get('maxazimuth')? control.get('maxazimuth').value : null;
  return start && end && start >= end ? { azimuthRangeValid: true } : null;
};

export const AngleValidator: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
  const start = control.get('minangle')? control.get('minangle').value : null;
  const end = control.get('maxangle')? control.get('maxangle').value : null;
  return start && end && start >= end ? { azimuthRangeValid: true } : null;
};

export const AltitudeRangeValidator: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
  const start = control.get('minaltitude')? control.get('minaltitude').value : null;
  const end = control.get('maxaltitude')? control.get('maxaltitude').value : null;
  return start && end && start >= end ? { altitudeRangeValid: true } : null;
};
export function forbiddenNameValidator(nameRe: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const forbidden = nameRe.test(control.value);
    return forbidden ? {forbiddenName: {value: true}} : null;
  };
}


/*export function AzimuthRangeValidator(fg: FormGroup) : ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const start = fg.get('minazimuth').value;
    const end = fg.get('maxazimuth').value;
    const allowed = start !== null && end !== null && start < end;
    return allowed ? {azimuthRangeValid: true} : {azimuthRangeValid: false};
  };
};*/

@Injectable({
  providedIn: 'root'
})
export class DataValidatorsService {

  constructor() { }

}
